// PREFETCH A ROUTE THE USER IS ABOUT TO OPEN (DESIGN-WL-PAGESLOT-OPEN-SPLIT-
// SEARCH-1 — Nika 2026-09-28: "improve speed of pageslot opening from any of
// the home page widgets").
//
//   el.call('prefetchSlotRoute', route) → true when a load started
//
// A pointer resting on, or focus reaching, something that opens a route (a
// home widget, an App strip tile, a launcher tile) starts that route's lazy
// chunk load NOW — the placeholder's own `scope.prefetch` (pages/lazyPage.js)
// — so the click finds the module already in the module cache and the window
// fills in without the network round trip. It mounts nothing and writes no
// state: a prefetch the user never follows costs one warm cache entry.
//
// The route resolves through the SAME chain the PageSlot mounts from
// (`root._slotResolve`, installed by pages/main.js, then `context.pages`), so
// a prefetch can never warm a different page than the one the click opens.
// Routes with nothing lazy behind them (the shell's eager pages, an installed
// app's module page — its bundle loads with the workspace) answer false.
//
// Once per route per shell: the set of started routes lives on the SHELL ROOT
// ELEMENT (the keyboard registry's storage rule — never module scope, never a
// window global, never root STATE), and a failed load forgets its route so the
// next hover may try again. Self-contained: every read goes through `this`.
export function prefetchSlotRoute(route) {
  const origin = this
  if (!route || !origin) return false
  const host = (typeof origin.getRoot === 'function' && origin.getRoot()) || origin
  const root = (origin.state && origin.state.root) || (host && host.state) || null
  const clean = String(route).split('?')[0].split('#')[0]
  if (!clean) return false
  const seen = host.__slotPrefetched || (host.__slotPrefetched = new Set())
  if (seen.has(clean)) return false
  let def = null
  try {
    def =
      (root && typeof root._slotResolve === 'function' && root._slotResolve(clean)) ||
      (origin.context && origin.context.pages && origin.context.pages[clean]) ||
      null
  } catch (_) {
    def = null
  }
  const prefetch = def && def.scope && def.scope.prefetch
  if (typeof prefetch !== 'function') return false
  seen.add(clean)
  try {
    // The loaders ride in the definition's scope (pages/lazyPage.js).
    const started = prefetch(def.scope)
    if (started && typeof started.catch === 'function') {
      started.catch(() => seen.delete(clean))
    }
  } catch (_) {
    seen.delete(clean)
    return false
  }
  return true
}
